import { assertUnreachable } from "./type-guards";

export function getContrastYIQ(
  hexcolor: string,
  // black and white on text on the opposite color bg
  // are usually very hard on the eye. Mixing a tiny
  // bit of the bg color into the text, eases it a lot.
  mode: "hard" | "soft" | "softer" = "soft",
) {
  const modString = hexcolor.replace("#", "");
  const r = parseInt(modString.slice(0, 2), 16);
  const g = parseInt(modString.slice(2, 4), 16);
  const b = parseInt(modString.slice(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  if (mode === "hard") return yiq >= 128 ? "black" : "white";
  if (mode === "soft")
    return yiq >= 128 ? `color-mix(in lch, black, ${hexcolor} 7%)` : `color-mix(in lch, white, ${hexcolor} 10%)`;
  if (mode === "softer")
    return yiq >= 128 ? `color-mix(in lch, black, ${hexcolor} 15%)` : `color-mix(in lch, white, ${hexcolor} 20%)`;

  assertUnreachable(mode);
}
